<template>
  <div>
    <v-text-field
      @click="handleOpenDialog"
      :label="label"
      :value="modelValue ? modelValue[itemText] : null"
      readonly
      :error-messages="errorMessages"
      placeholder="Selecione um item"
    >
      <template #append>
        <v-btn @click="handleOpenDialog" color="primary" icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
    </v-text-field>
    <DialogoLista
      ref="dialogo"
      itemTitle="nome"
      itemKey="id"
      @click:item="handleSelectItem"
    />
  </div>
</template>

<script>
import DialogoLista from "../dialogos/DialogoLista.vue";

export default {
  components: {
    DialogoLista
  },

  model: {
    prop: "modelValue",
    event: "change"
  },

  props: {
    label: String,
    placeholder: {
      type: String,
      default: "Selecione um item"
    },
    modelValue: Object,
    loader: Function,
    errorMessages: Object,
    itemText: {
      type: String,
      default: "text"
    },
    itemValue: {
      type: String,
      default: "id"
    },
    responseKey: String
  },

  data() {
    return {
      items: [],
      loading: false,
      loaded: false
    };
  },

  methods: {
    async loadItems() {},

    async handleOpenDialog() {
      this.$refs.dialogo.open("Escolha um item");
      if (this.loaded) {
        this.$refs.dialogo.items = this.items;
        return;
      }

      this.$refs.dialogo.setLoading(true);

      try {
        const response = await this.loader();
        if (this.responseKey) {
          this.$refs.dialogo.items = response[this.responseKey];
          this.items = response[this.responseKey];
        } else {
          this.$refs.dialogo.items = response;
          this.items = response;
        }
        this.loaded = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.$refs.dialogo.setLoading(false);
      }
    },

    handleSelectItem(item) {
      console.log(item);
      this.$emit("change", { ...item });
      this.$refs.dialogo.close();
    }
  }
};
</script>
